module.exports = __webpack_public_path__ + "media/images/icons/flags/HK-92f352c780330dbf98cbd921d2cb22da.svg";